exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".h-selected-course[data-v-e3163554] {\n  margin: 0 0 30px;\n}\n", ""]);

// exports
